module.exports = __webpack_public_path__ + "img/1453066183.3b6ecb0f.jpg";